'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = createApiClient;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function absoluteUrl(path, config) {
  if (__SERVER__) return 'http://' + config.host + ':' + config.port + path;
  return '/api' + path;
}

function requestOptions(config) {
  var options = { mode: 'cors', credentials: 'same-origin', headers: {} };
  var cookie = __SERVER__ ? config.req && config.req.headers && config.req.headers.cookie : document && document.cookie;

  if (cookie) options.headers.Cookie = cookie;

  return options;
}

function localise(query, config) {
  if (query.locale) return query;

  var locale = config.req && config.req.language || window && window.__locale;
  return (0, _extends3.default)({}, query, { locale: locale });
}

function makeRequest(apiRequest, method, query, config) {
  return new _promise2.default(function (accept, reject) {
    var localisedOptions = localise(query, config);

    apiRequest[method](localisedOptions).then(function (res) {
      return accept(res);
    }).catch(function (err) {
      return reject(err);
    });
  });
}

var ApiClient = function ApiClient(path, config) {
  var _this = this;

  (0, _classCallCheck3.default)(this, ApiClient);

  var apiRequest = fetchival(absoluteUrl(path, config), requestOptions(config));

  ApiClient.methods.forEach(function (method) {
    _this[method] = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return makeRequest(apiRequest, method, options, config);
    };
  });
};

ApiClient.methods = ['get', 'post', 'put', 'patch', 'delete'];
function createApiClient() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (path) {
    return new ApiClient(path, config);
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/chemist/dist/helpers/createApiClient.js
// module id = 649
// module chunks = 0